// Базовый блок
export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div className={`animate-pulse bg-gray-200 rounded-xl ${className}`} />
  );
}

// Скелетон карточки специалиста (повторяет структуру SpecialistCard)
export function SpecialistCardSkeleton() {
  return (
    <div className="bg-bg-surface rounded-2xl border border-border p-3 flex flex-col">
      {/* Шапка: фото 88x88 + инфо */}
      <div className="flex items-start gap-3 mb-2">
        <Skeleton className="w-[88px] h-[88px] rounded-xl flex-shrink-0" />
        <div className="flex-1 pt-0.5">
          <Skeleton className="h-4 w-28 mb-2" />
          <Skeleton className="h-4 w-20 rounded-full mb-2" />
          <Skeleton className="h-3 w-24" />
        </div>
      </div>
      {/* Категория */}
      <Skeleton className="h-3 w-24 mb-2" />
      {/* Услуги (до 3) */}
      <div className="flex flex-col gap-1.5 mb-2">
        <Skeleton className="h-9 w-full rounded-lg" />
        <Skeleton className="h-9 w-full rounded-lg" />
        <Skeleton className="h-9 w-full rounded-lg" />
      </div>
      {/* CTA */}
      <div className="border-t border-border-subtle pt-2 flex justify-between items-center">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-8 w-20 rounded-lg" />
      </div>
    </div>
  );
}

// Скелетон страницы специалиста /specialists/[id]
export function SpecialistPageSkeleton() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Левая колонка */}
        <div className="lg:col-span-1">
          <div className="bg-bg-surface rounded-2xl border border-border p-6">
            <div className="flex flex-col items-center text-center mb-6">
              <Skeleton className="w-24 h-24 rounded-full mb-4" />
              <Skeleton className="h-5 w-40 mb-2" />
              <Skeleton className="h-4 w-28 mb-1" />
              <Skeleton className="h-4 w-24" />
            </div>
            <Skeleton className="h-3 w-full mb-2" />
            <Skeleton className="h-3 w-5/6 mb-2" />
            <Skeleton className="h-3 w-4/6 mb-6" />
            <Skeleton className="h-10 w-full rounded-xl" />
          </div>
        </div>
        {/* Правая колонка */}
        <div className="lg:col-span-2 space-y-4">
          <div className="bg-bg-surface rounded-2xl border border-border p-6">
            <Skeleton className="h-5 w-32 mb-4" />
            {[1,2,3].map(i => (
              <div key={i} className="flex justify-between items-center py-3 border-b border-border-subtle last:border-0">
                <div>
                  <Skeleton className="h-4 w-36 mb-1.5" />
                  <Skeleton className="h-3 w-24" />
                </div>
                <Skeleton className="h-8 w-20 rounded-xl" />
              </div>
            ))}
          </div>
          <div className="bg-bg-surface rounded-2xl border border-border p-6">
            <Skeleton className="h-5 w-40 mb-4" />
            <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
              {[1,2,3,4,5,6].map(i => (
                <Skeleton key={i} className="h-10 rounded-xl" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Скелетон страницы бронирований
export function BookingsSkeleton() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <Skeleton className="h-8 w-48 mb-6" />
      {[1,2,3].map(i => (
        <div key={i} className="bg-bg-surface rounded-2xl border border-border p-5 mb-4">
          <div className="flex justify-between items-start mb-3">
            <div className="flex items-center gap-3">
              <Skeleton className="w-12 h-12 rounded-full" />
              <div>
                <Skeleton className="h-4 w-32 mb-1.5" />
                <Skeleton className="h-3 w-24" />
              </div>
            </div>
            <Skeleton className="h-6 w-24 rounded-full" />
          </div>
          <div className="flex gap-4">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-20" />
          </div>
        </div>
      ))}
    </div>
  );
}

// Скелетон страницы избранного
export function FavoritesSkeleton() {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <Skeleton className="h-8 w-48 mb-6" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1,2,3,4,5,6].map(i => (
          <SpecialistCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );
}
